import { ShieldCheck } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const Gdpr = () => {
  const { t } = useLanguage();

  return (
    <section id="gdpr" className="bg-[#f8fafc] py-20 lg:py-28" data-testid="gdpr-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="section-label" data-testid="gdpr-label">{t.gdpr.label}</p>
        <h2
          className="font-display mt-4 flex items-center gap-3 text-3xl font-bold tracking-tight text-[#0d2b52] sm:text-4xl"
          data-testid="gdpr-title"
        >
          <ShieldCheck className="h-8 w-8 text-[#1d6fd1]" />
          {t.gdpr.title}
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {t.gdpr.items.map((item, i) => (
            <article
              key={i}
              className="border border-[#e2e8f0] bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-[#1d6fd1]"
              data-testid={`gdpr-card-${i}`}
            >
              <h3 className="font-display text-lg font-bold text-[#0d2b52]">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#475569]">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
